import React from 'react';

import {
  Box,
  Container,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

import { makeBlockStyles, useBlockStyles } from '../hooks/useStyles';
import { BlockBuilder, BlockTable } from '../types/_blocks.types';

const useStyles = makeBlockStyles(() => ({
  tableWrapper: {
    maxHeight: '100vh',
    overflowY: 'scroll',
  },
  table: {
    borderCollapse: 'collapse',
    width: '100%',
  },
  tableHead: {
    '& th': {
      fontWeight: 600,
      textAlign: 'center',
    },
  },
  tableCell: {
    border: '1px solid black',
    padding: '8px',
    minWidth: '170px',
    '& p, ul': {
      margin: 0,
    },
    '& p:not(:last-child)': {
      paddingBottom: '6px',
    },
    '& ul:not(:last-child)': {
      paddingBottom: '10px',
    },
  },
}));

type TableProps = BlockBuilder<BlockTable>;

export const TableBlock: React.FC<TableProps> = ({ block }) => {
  const { thead, rows } = block;
  const classes = useBlockStyles(useStyles, block);

  return (
    <Box className={classes.boxBlock} style={{ maxWidth: '100vw' }}>
      <Container>
        <Grid container justifyContent="center" style={{ overflowX: 'scroll' }}>
          <Grid item xs={12} md={9} className={classes.tableWrapper}>
            <Table className={classes.table}>
              <TableHead className={classes.tableHead}>
                <TableRow>
                  {thead?.map((header, index) => (
                    <TableCell key={`H${index}`} className={classes.tableCell}>
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.map((rowData, rowIndex) => (
                  <TableRow key={`R${rowIndex}`}>
                    {Object.values(rowData).map((cell, cellIndex) => (
                      <TableCell
                        key={`C${rowIndex}${cellIndex}`}
                        className={classes.tableCell}
                        {...(rowData.length === 1 && { colSpan: rows.length })}
                      >
                        <div dangerouslySetInnerHTML={{ __html: cell }} />
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
